var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPointerRight(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 7,
    height: 11,
    viewBox: "0 0 7 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.875025 10.6249C0.725025 10.4749 0.650024 10.2999 0.650024 10.0999C0.650024 9.8999 0.725025 9.7249 0.875025 9.5749L4.95002 5.4999L0.875025 1.4249C0.725025 1.2749 0.650024 1.0999 0.650024 0.899902C0.650024 0.699902 0.725025 0.524902 0.875025 0.374902C1.02502 0.224902 1.20002 0.149902 1.40002 0.149902C1.60002 0.149902 1.77503 0.224902 1.92502 0.374902L6.42502 4.8749C6.50836 4.95824 6.57102 5.0539 6.61302 5.1619C6.65436 5.27057 6.67502 5.38324 6.67502 5.4999C6.67502 5.61657 6.65436 5.7289 6.61302 5.8369C6.57102 5.94557 6.50836 6.04157 6.42502 6.1249L1.92502 10.6249C1.77503 10.7749 1.60002 10.8499 1.40002 10.8499C1.20002 10.8499 1.02502 10.7749 0.875025 10.6249Z",
    fill: "#707683"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPointerRight);
export default __webpack_public_path__ + "static/media/pointer-right.5fdded82.svg";
export { ForwardRef as ReactComponent };